import React from "react";
import { withRouter } from "react-router-dom";

import moment from "moment";

import Select from "react-select";

import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";

import styles from "./style.module.css";

export default class ScenarioSelect extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { allScenarios, selectedScenario, projectId, viewScenario, saveScenario, hasSameScenario, menuPlacement } =
      this.props;

    const formatOptionLabel = (option, meta) => {
      const selectedValue =
        meta?.selectValue?.length > 0 &&
        meta.selectValue.find((selectedOption) => selectedOption.value === option.value);
      let selectOptionStyle = { color: "#7E69D7" };
      if (meta.context === "menu" && selectedValue) selectOptionStyle.color = "#FFF";
      return option.isApproved ? (
        <div style={selectOptionStyle}>
          <img src={ReviewDeployIcon} style={{ height: "18px", marginRight: "6px" }} />
          {option?.label}
        </div>
      ) : (
        <div style={selectOptionStyle}>{option?.label}</div>
      );
    };

    return (
      <div className={styles.scenarioChooser}>
        <div className={styles.scenarios}>
          {selectedScenario === undefined ? (
            "Default Scenario"
          ) : (
            <div className={styles.sPicker}>
              <Select
                formatOptionLabel={formatOptionLabel}
                options={allScenarios.map((s, i) => ({
                  label: s?.originalScenario?.name,
                  value: s?.originalScenario?.name,
                  index: i,
                  isApproved: s?.isApproved
                }))}
                value={{
                  label: !hasSameScenario ? "New Scenario" : selectedScenario?.originalScenario?.name,
                  value: selectedScenario?.originalScenario?.name,
                  isApproved: !hasSameScenario ? false : selectedScenario?.isApproved
                }}
                onChange={(val) => viewScenario(allScenarios[val?.index]?.scenario, val?.index)}
                menuPlacement={menuPlacement !== undefined ? menuPlacement : "top"}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
